export const BreRidersRate = {
  COURIER: '25',
  RIDER: '45',
  UPS: '18',
};

export const BreRidersPay = {
  RIDER: '37.50',
};
